import React from 'react'
export class PrintContainer extends React.PureComponent {
    render(){
        return (
        <div>
            {this.props.children}
        </div>
        )
    }
}